import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth/service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Review Center DevOps';
  constructor(private readonly oauthService: AuthService) {

  }
  ngOnInit(): void {
  }
}
